export default {
    api_url: process.env.VUE_APP_AS_API_URL,
    app_url: process.env.VUE_APP_AS_API_URL + "/app",
    resources_url: process.env.VUE_APP_RESOURCES_URL,
    assets_url: process.env.VUE_APP_URL + "/static"
};
